'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _busSchemaDirective = require('./bus-schema.directive');

var _busSchemaDirective2 = _interopRequireDefault(_busSchemaDirective);

angular.module('Components').directive('busSchema', _busSchemaDirective2['default']);


/** WEBPACK FOOTER **
 ** ./client/components/bus-schema/index.js
 **/